import { PartialTranslation } from '../translations';

export const si: PartialTranslation = {
  newChat: 'නව චැට්',
  search: 'සොයන්න',
  user: 'පරිශීලක',
  settings: 'සැකසුම්',
  language: 'භාෂාව',
  getHelp: 'උදව් ගන්න',
  viewAllPlans: 'සියලු සැලසුම් බලන්න',
  learnMore: 'තව දැනගන්න',
  logOut: 'ලොග් අවුට්',
  chooseLanguage: 'භාෂාව තෝරන්න',
  chooseYourPreferredLanguage: 'ඔබේ කැමති භාෂාව තෝරන්න',
  searchLanguages: 'භාෂා සොයන්න...',
  autoDetect: 'ස්වයංක්‍රීය හඳුනාගැනීම',
  noLanguagesFound: 'භාෂා හමු නොවිය',
  askAnything: 'ඕනෑම දෙයක් අහන්න',
  lawhelperAi: 'Lawhelper.ai',
  personal: 'පුද්ගලික',
  freePlan: 'නොමිලේ සැලසුම',
  current: 'දැනට',
  close: 'වසන්න',
  archive: 'සංරක්ෂිතාගාරය',
  delete: 'මකන්න',
  confirmDelete: 'ඔබට මෙම චැට් එක මකා දැමීමට අවශ්‍යද?',
  confirmArchive: 'ඔබට මෙම චැට් එක සංරක්ෂිතාගාරගත කිරීමට අවශ්‍යද?',
  deleteCannotUndo: 'මෙම ක්‍රියාව ප්‍රතිවර්තනය කළ නොහැක.',
  archiveCanFind: 'සංරක්ෂිතාගාරගත කිරීමෙන් පසු ඔබට එය සංරක්ෂිතාගාර ලැයිස්තුවෙන් සොයා ගත හැක.',
  resources: 'සම්පත්',
  addResource: 'සම්පත් එකතු කරන්න',
  deleteResource: 'සම්පත් මකන්න',
  noMatchingResourcesFound: 'ගැලපෙන සම්පත් හමු නොවිය',
  noResourcesAvailable: 'සම්පත් ලබා ගත නොහැක',
  hideResources: 'සම්පත් සඟවන්න',
  showResources: 'සම්පත් පෙන්වන්න',
  typeMessage: 'පණිවිඩයක් ටයිප් කරන්න...',
  thinkingOptions: 'චින්තන විකල්ප',
  deleteFile: 'ගොනුව මකන්න',
  clearSelection: 'තේරීම හිස් කරන්න',
  addAttachment: 'ඇමුණුම එකතු කරන්න',
  sendMessage: 'පණිවිඩය යවන්න',
  deepInsight: 'ගැඹුරු අවබෝධය · මතුපිට විශ්ලේෂණය',
  deepInsightDesc: 'ප්‍රධාන කරුණු ඉක්මනින් අවබෝධ කර ගැනීම',
  deepExploration: 'ගැඹුරු ගවේෂණය · සවිස්තරාත්මක විශ්ලේෂණය',
  deepExplorationDesc: 'බහුමාන ගැඹුරු පර්යේෂණ',
  deepDeconstruction: 'ගැඹුරු විනිර්මාණය · ක්‍රමානුකූල තර්කය',
  deepDeconstructionDesc: 'තට්ටුව අනුව ප්‍රගතිශීලී විශ්ලේෂණය',
  contractReview: 'ගිණුම් සමාලෝචනය · අවදානම් හඳුනාගැනීම',
  contractReviewDesc: 'වගන්ති විශ්ලේෂණය සහ අනුකූලතා පරීක්ෂාව',
  textPolish: 'පාඨ ඔප දැමීම · වෘත්තීය ප්‍රකාශනය',
  textPolishDesc: 'භාෂා ප්‍රශස්තකරණය සහ ව්‍යුහ ගැලපීම',
  legalDocuments: 'නීතිමය ලිඛිත · සම්මත කර්මාන්ත',
  legalDocumentsDesc: 'වෘත්තීය නීතිමය ලේඛන ලේඛනය',

  // 认证和隐私翻译 (English fallback - needs translation)
  login: 'පිවිසෙන්න',
  register: 'ලියාපදිංචි වන්න',
  welcomeBack: 'LawHelper වෙත සාදරයෙන් පිළිගනිමු',
  loginSubtitle: 'ඔබේ AI නීති පර්යේෂණ සහායක',
  continueWithGoogle: 'Google සමඟ ඉදිරියට යන්න',
  continueWithMicrosoft: 'Microsoft සමඟ ඉදිරියට යන්න',
  continueWithWeChat: 'WeChat සමඟ ඉදිරියට යන්න',
  orContinueWith: 'හෝ සමඟ ඉදිරියට යන්න',
  emailTab: 'ඊමේල්',
  phoneTab: 'දුරකථන',
  emailPlaceholder: 'ඔබේ ඊමේල් ඇතුළත් කරන්න',
  phonePlaceholder: 'දුරකථන අංකය ඇතුළත් කරන්න',
  codePlaceholder: 'ඉලක්කම් 6 කේතය ඇතුළත් කරන්න',
  sending: 'යවමින්...',
  verifying: 'සත්‍යාපනය කරමින්...',
  verify: 'සත්‍යාපනය කරන්න',
  sendMagicLink: 'මැජික් සබැඳිය යවන්න',
  getVerificationCode: 'කේතය ලබා ගන්න',
  resendCode: 'කේතය නැවත යවන්න',
  resendIn: 'නැවත යවන්න',
  magicLinkSent: 'මැජික් සබැඳිය ඔබේ ඊමේල් වෙත යවා ඇත',
  magicLinkHint: 'අපි ඔබේ ඊමේල් වෙත ආරක්ෂිත සබැඳියක් යවමු',
  otpSent: 'සත්‍යාපන කේතය යවා ඇත',
  agreeToTerms: 'ඉදිරියට යාමෙන්, ඔබ එකඟ වේ',
  privacyPolicy: 'පෞද්ගලිකත්ව ප්‍රතිපත්තිය',
  termsOfService: 'සේවා නියමයන්',
  and: 'සහ',
  privacyTitle: 'ඔබේ පෞද්ගලිකත්වය වැදගත්',
  privacyIntro: 'හොඳම අත්දැකීම ලබා දීමට අපි කුකීස් සහ සමාන තාක්ෂණ භාවිතා කරමු.',
  essentialCookies: 'අත්‍යවශ්‍ය කුකීස්',
  essentialDesc: 'වෙබ් අඩවිය ක්‍රියා කිරීමට අවශ්‍යයි',
  analyticsCookies: 'විශ්ලේෂණ කුකීස්',
  analyticsDesc: 'සේවාව වැඩිදියුණු කිරීමට උපකාරී වේ',
  marketingCookies: 'අලෙවිකරණ කුකීස්',
  marketingDesc: 'පුද්ගල අන්තර්ගතය සඳහා භාවිතා කරයි',
  acceptAll: 'සියල්ල පිළිගන්න',
  essentialOnly: 'අත්‍යවශ්‍ය පමණි',
  customize: 'අභිරුචිකරණය',
  savePreferences: 'මනාපයන් සුරකින්න',
  back: 'ආපසු',
  readPrivacyPolicy: 'අපගේ පෞද්ගලිකත්ව ප්‍රතිපත්තිය කියවන්න',
  cookiePolicy: 'කුකී ප්‍රතිපත්තිය',
  gdprCompliance: 'GDPR',
  piplCompliance: 'PIPL',

  // AI工具面板
  aiReview: 'AI සමාලෝචනය',
  aiDraft: 'AI කෙටුම්පත',
  smartAssistant: 'අච්චුව',

  // 知识库搜索
  enableKnowledgeSearch: 'සෙවීම සක්‍රීය කරන්න',
  knowledgeSearchDesc: 'AI ඔබේ ලේඛනවල සොයයි',
  clickToDisable: 'අක්‍රීය',
  clickToEnable: 'සක්‍රීය',

  // Landing page translations
  tagline: 'AI-Powered Legal Intelligence',
  heroTitle1: 'Legal AI',
  heroTitle2: 'Simplified.',
  jurisdictionsLabel: 'Jurisdictions',
  accuracyLabel: 'Accuracy',
  fasterLabel: 'Faster',
  availableLabel: 'Available',
  platformCapabilities: 'Platform Capabilities',
  testimonialQuote: '"LawHelper has transformed how we handle legal work. Contract review is 10x faster, with incredible accuracy."',
  testimonialAuthor: 'Legal Professional',
  testimonialPosition: 'Partner at Top Law Firm',
  viewPricing: 'View Pricing',
  footerPricing: 'Pricing',
  footerPrivacy: 'Privacy',
  footerTerms: 'Terms',
  footerContact: 'Contact',
  footerCopyright: '© 2024 LawHelper. All rights reserved.',

  // Onboarding Guide
  onboardingWelcome: 'Welcome to Lawhelper.ai',
  onboardingSkip: 'Skip',
  onboardingNext: 'Next',
  onboardingPrev: 'Back',
  onboardingGetStarted: 'Get Started',
  onboardingSlide1Title: 'AI Legal Chat',
  onboardingSlide1Desc: 'Ask any legal question and get precise, jurisdiction-aware answers powered by advanced AI.',
  onboardingSlide2Title: 'Case Folder System',
  onboardingSlide2Desc: 'Organize your documents by case. Upload files and control which materials AI uses as context.',
  onboardingSlide3Title: 'Local Folder Access',
  onboardingSlide3Desc: 'Connect local directories in the browser. Preview, edit, and send files to AI chat.',
  onboardingSlide4Title: 'AI Drafting & Review',
  onboardingSlide4Desc: 'Draft legal documents with AI and review contracts to identify risks automatically.',
  onboardingGuide: 'Guide',
  mentionFiles: "Reference a file",

  // Auto-synced keys
  chats: 'Chats',
  archived: 'Archived',
  restore: 'Restore',
  noArchivedChats: 'No archived chats',
  backToChats: 'Back to Chats',
  closeResourcesPanel: 'Close Resources Panel',
  uploading: 'Uploading %{fileName}...',
  processing: 'Processing %{fileName}...',
  uploadSuccess: '✓ %{fileName} uploaded successfully',
  uploadError: '✗ Upload failed: %{error}',
  quickAnswer: 'ඉක්මන් පීලිව',
  quickAnswerDesc: 'Fast response for simple questions',
  cancelRequest: 'අහොසි කරන්න',
  library: 'පුස්තකාලය',
  filterAll: 'සියල්ල',
  filterChat: 'Chats',
  filterReview: 'Review',
  filterDraft: 'Draft',
  filterTemplate: 'Template',
  filterForm: 'Form',
  thinking: 'සිතන්නෙට...',
  thinkingProcess: 'Thinking Process',
  analyzingLegalLogic: 'Analyzing legal logic...',
  lawhelperThinking: 'Lawhelper is thinking...',
  serviceError: 'Service Error',
  uploaded: 'Uploaded',
  settingsGeneral: 'සාමාන්‍ය',
  settingsNotifications: 'Notifications',
  settingsAppearance: 'Appearance',
  settingsProfile: 'Profile',
  settingsResponseNotifications: 'Response Notifications',
  settingsResponseNotificationsDesc: 'Get notified when AI finishes a response',
  settingsColorMode: 'Color Mode',
  settingsLight: 'Light',
  settingsDark: 'Dark',
  settingsSystem: 'System',
  about: 'පිළිබඳව',
  reviewTitle: 'Document Review',
  exitReview: 'Exit Review',
  uploadPrompt: 'Upload PDF to start review',
  uploadButton: 'Select File',
  startChatConfig: 'Type "Review this document" to start',
  reviewPlaceholder: 'Type a message or "Review this document"...',
  analyzing: 'Reviewing...',
  reviewComplete: 'Review Complete',
  issuesFound: 'Found %{count} issues',
  draftTitle: 'Legal Document Drafting',
  draftPlaceholder: 'Edit here or ask AI to generate...',
  analyzingTemplate: 'Analyzing template file %{name}...',
  templateAnalyzed: '✅ Template %{name} analyzed! Tell me how you want to modify or fill this template.',
  templateAnalysisPrompt: 'Analyze key clauses of this template',
  parsingFailed: '⚠️ Failed to parse file, but you can still describe your needs.',
  generating: 'Generating...',
  generatedSuccess: '✅ Document generated! You can view and edit in the editor.',
  drafterWelcome: 'Welcome to AI Document Assistant',
  drafterYouCan: 'You can:',
  drafterUploadTemplate: 'Upload a template for AI to analyze',
  drafterDescribeNeeds: 'Describe your document requirements',
  drafterLetAiHelp: 'Let AI help you draft contracts, agreements, etc.',
  drafterExamples: 'Examples:',
  drafterExampleRental: '"Help me draft a rental agreement"',
  drafterExampleLabor: '"Fill in the labor contract based on template"',
  drafterInputPlaceholder: 'Describe your document needs...',
  drafterThinking: 'Thinking...',
  drafterHistoryTitle: 'History',
  drafterNoHistory: 'No history yet',
  drafterNewChat: 'New Chat',
  drafterHistory: 'History',
  drafterRemoveAttachment: 'Remove attachment',
  drafterLineHeight: 'Line Height',
  drafterLineHeightSuffix: 'x',
  drafterExportWord: 'Export as Word (.docx)',
  drafterExportPdf: 'Export as PDF',
  drafterSave: 'Save Document',
  drafterDownload: 'Download Document',
  drafterUndo: 'Undo',
  drafterRedo: 'Redo',
  drafterBold: 'Bold',
  drafterItalic: 'Italic',
  drafterStrike: 'Strikethrough',
  drafterUnderline: 'Underline',
  drafterHighlight: 'Highlight',
  drafterLink: 'Insert Link',
  drafterAlignLeft: 'Align Left',
  drafterAlignCenter: 'Align Center',
  drafterAlignRight: 'Align Right',
  drafterAlignJustify: 'Justify',
  drafterList: 'List',
  drafterBulletList: 'Bullet List',
  drafterOrderedList: 'Ordered List',
  drafterTaskList: 'Task List',
  drafterOpenResource: 'Open Resources Panel',
  drafterStopGeneration: 'Stop generation',
  drafterAgentMode: 'Agent mode enabled | Click to switch to normal chat',
  drafterAgentModeOn: 'Agent mode enabled | Click to switch to normal chat',
  drafterAgentModeOff: 'Normal chat mode | Click to switch to Agent mode',
  drafterUploadAttachment: 'Upload attachment',
  drafterExit: 'Exit',
  drafterConfirm: 'Confirm',
  drafterOpenLink: 'Open link',
  drafterDeleteLink: 'Delete link',
  drafterQuote: 'Quote',
  workflowTitle: 'AI Workflow',
  workflowRunning: 'Running...',
  workflowReady: 'Ready',
  workflowCompleted: 'Completed',
  workflowStartFailed: 'Workflow start failed',
  workflowExecutionFailed: 'Workflow execution failed',
  workflowInterrupted: 'Workflow interrupted',
  workflowProcessing: 'Processing...',
  workflowStepsCompleted: 'steps completed',
  workflowStepsTotal: 'Workflow completed (%{count} steps)',
  acceptChanges: 'Accept Changes',
  rejectChanges: 'Reject Changes',
  changesAccepted: 'Changes accepted',
  changesRejected: 'Changes rejected',
  stopWorkflow: 'Stop',
  restartWorkflow: 'Restart',
  startDrafting: 'Start Drafting',
  interrupt: 'Stop',
  documentSubject: 'Document Subject *',
  documentType: 'Document Type',
  jurisdiction: 'Jurisdiction',
  specialRequirements: 'Special Requirements (optional)',
  clickStartDrafting: 'Click "Start Drafting" to begin workflow',
  docTypeContract: 'Contract',
  docTypeAgreement: 'Agreement',
  docTypeNotice: 'Notice',
  docTypeLetter: 'Letter',
  docTypePetition: 'Petition',
  docTypeWill: 'Will',
  docTypePowerOfAttorney: 'Power of Attorney',
  countryChina: 'China',
  countryUSA: 'United States',
  countryGermany: 'Germany',
  countryJapan: 'Japan',
  countryFrance: 'France',
  countryUK: 'United Kingdom',
  citationVerified: 'Verified',
  citationUnverified: 'Unverified',
  imageLoadFailed: 'Image failed to load',
  smartDocTitle: 'ස්මාර්ට් ලිපිය සහායක',
  smartDocChatTitle: 'AI Document Assistant',
  smartDocDropPrompt: 'Drop PDF file here',
  smartDocSelectFile: 'Select File',
  smartDocOr: 'or',
  smartDocWelcomeTitle: 'Welcome to AI Document Assistant',
  smartDocWelcomeYouCan: 'You can:',
  smartDocUploadForAI: 'Upload a template for AI to analyze',
  smartDocDescribeDoc: 'Describe your document requirements',
  smartDocLetAIDraft: 'Let AI help you draft contracts, agreements, etc.',
  smartDocExamples: 'Examples:',
  smartDocExampleRental: '"Help me draft a rental agreement"',
  smartDocExampleLabor: '"Fill in the labor contract based on template"',
  smartDocInputPlaceholder: 'Describe your document needs...',
  smartDocRemoveAttachment: 'Remove attachment',
  smartDocOpenResources: 'Open Resources Panel',
  smartDocExit: 'Exit',
  reviewStartFailed: 'Review workflow start failed',
  reviewFailed: 'Review failed',
  reviewFoundIssues: 'Review complete, found %{count} issues.',
  cannotReadStream: 'Cannot read response stream',
  parseEventFailed: 'Failed to parse workflow event',
  errorPrefix: 'දෝෂය',
  unknownError: 'Unknown error',
  file: 'පිළ',
  loading: 'පූරයනය...',
  localFolders: 'Local Folders',
  selectLocalFolder: 'Select Local Folder',
  reselectFolder: 'Change Folder',
  addToContext: 'Add to Chat',
  saveFile: 'Save',
  renameFile: 'Rename',
  fileSaved: 'File saved successfully',
  fileRenamed: 'File renamed to %{name}',
  browserNotSupported: 'Your browser does not support local folder access',
  noFolderSelected: 'Select a local folder to browse files',
  scanningFolder: 'Scanning folder...',
  selectFileToPreview: 'Select a file to preview',
  aiAnalyze: 'AI විශ්ලිෂය',
};
